import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from '@hooks/useAuth'
import MainLayout from '@components/layouts/MainLayout'
import AuthLayout from '@components/layouts/AuthLayout'

// Auth Pages
import LoginPage from '@pages/auth/LoginPage'

// Minimal Main Pages
import DashboardPage from '@pages/DashboardPage'
import SimulatorPage from '@pages/SimulatorPage'
import SimulatorPageNew from '@pages/SimulatorPageNew'
import RulesPage from '@pages/RulesPage'
import ScenariosPage from '@pages/ScenariosPage'
import ScenarioDetailPage from '@pages/ScenarioDetailPage'
import AnalyticsPage from '@pages/AnalyticsPage'
import SettingsPage from '@pages/SettingsPage'

// Protected Route Component
function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth()
  
  if (isLoading) return null
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }
  
  return children
}

// Public Route Component (redirect if authenticated)
function PublicRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth()
  
  if (isLoading) return null
  if (isAuthenticated) {
    return <Navigate to="/" replace />
  }
  
  return children
}

export default function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<AuthLayout />}>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />
      </Route>

      {/* Protected Routes */}
      <Route
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/simulador" element={<SimulatorPageNew />} />
        <Route path="/simulador-old" element={<SimulatorPage />} />
        <Route path="/regras" element={<RulesPage />} />
        <Route path="/cenarios" element={<ScenariosPage />} />
        <Route path="/cenarios/:id" element={<ScenarioDetailPage />} />
        <Route path="/analises" element={<AnalyticsPage />} />
        <Route path="/configuracoes" element={<SettingsPage />} />
      </Route>

      {/* 404 Route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}







